"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRootElement = withRootElement;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _useRootElement2 = require("./useRootElement");
var _excluded = ["rootElement", "getRootElement"];
function withRootElement(Component) {
  var RootElementResolver = function RootElementResolver(_ref, ref) {
    var rootElement = _ref.rootElement,
      getRootElement = _ref.getRootElement,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var _useRootElement = (0, _useRootElement2.useRootElement)(),
      globalRoot = _useRootElement.rootElement;
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      ref: ref,
      rootElement: rootElement !== null && rootElement !== void 0 ? rootElement : getRootElement ? getRootElement() : globalRoot
    }, props));
  };
  return /*#__PURE__*/_react["default"].forwardRef(RootElementResolver);
}